<template>
  <div class="va-row">
    <div class="flex md12 xs12">
      <!-- :methodList="methodList" -->
      <recurrings-list-filter
        @searchReset="searchReset"
        @searchOrder="searchOrder"
        :value-app.sync="filterData.valueApp"
        :value-currency.sync="filterData.valueCurrency"
        :value-method.sync="filterData.valueMethod"
        :value-status.sync="filterData.valueStatus"
        :value-time.sync="filterData.valueTime"
        :curr-time-zone.sync="currTimeZone"
        :date-vals.sync="dateVals"
        :value-mode.sync="filterData.valueMode"
        :search-val.sync="filterData.searchVal"
        :appList="appList"
        :currencyList="currencyList"
        :statusList="statusList"
        :timeModeList="timeModeList"
        :timeZoneList="timeZoneList"
        :pickerOptions="pickerOptions"
        :modeList="modeList"
        :fileTypeOptions="fileTypeOptions"
        :queryDate="queryDate"
      />
    </div>

    <div class="flex xs12 md12 w-table">
      <vuestic-widget id="dategridPayOrder">
        <!-- <div class="va-row">
            <div class="flex md6">
            </div>
            <div class="flex md6 text-right">
              <button class="btn btn-info btn-micro mr-4" @click="downloadLogs">
                <div class="btn-with-icon-content">
                  <i class="ion-md-download ion"></i>
                  {{ "basic.button.downloadLoged" | translate }}
                </div>
              </button>
              <button class="btn btn-info btn-micro" @click="download">
                <div class="btn-with-icon-content">
                  <i class="ion-md-download ion"></i>
                  {{ "basic.button.download" | translate }}
                </div>
              </button>
            </div>
        </div> -->
        <div class="table-responsive">
          <table class="table table-striped first-td-padding">
            <thead>
              <tr>
                <th v-for="(item, index) in tableHeaderList" :key="index">
                  {{ item.label | translate }}
                </th>
              </tr>
            </thead>
            <tbody v-if="list && list.length > 0">
              <tr v-for="(item, index) in list" :key="index">
                <td>
                  <span @click="fetchDetails(item)"><a href="javascript:void(0);" class="alink">{{ item.out_trade_no }}</a></span>
                </td>
                <td>{{ item.app_name }}</td>
                <td>{{ dateFormat(item.create_time)}}</td>
                <td> {{ item.order_currency }} {{ item.order_amount.toFixed(2) }} </td>
                <td align="right">
                  <el-tag
                    effect="dark"
                    disable-transitions
                    :color="getStatusColor(item.recurring_status)"
                    >{{ item.recurring_status }}</el-tag
                  >
                </td>
                <td> {{ item.recurring_interval }} </td>
                <td> {{ item.recurring_quantity }} </td>
                <td> {{ item.current_stage }} </td>
                <td> {{ item.order_currency }} {{ item.trial_amount.toFixed(2) }} </td>
                <td> {{ dateFormat(item.prev_exec_time*1000) }} </td>
                <td> {{ dateFormat(item.next_exec_time*1000) }} </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="11" v-text="noData"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="block" v-if="isMobile === 'pc'">
          <pagination
            v-show="total > 0"
            :total="total"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :page.sync="page"
            :limit.sync="limit"
            @pagination="orderData"
          />
        </div>
        <div class="block" v-else>
          <pagination
            v-show="total > 0"
            :total="total"
            layout="total, prev, pager, next"
            background
            :page.sync="page"
            :limit.sync="limit"
            @pagination="orderData"
          />
        </div>
      </vuestic-widget>
    </div>

    <!-- 子订单弹框 -->
    <!-- <vuestic-modal
      ref="recurringsModal"
      :okText="'modal.confirm2' | translate"
      style="height: 100%; width: 60vw"
      :okClass="'btn btn-primary btn-micro'"
      :cancelClass="'btn btn-secondary btn-micro'"
      :cancelText="'modal.cancel2' | translate"
      :noButtons="true"
      :large="true"
    >
      <div slot="title">{{ "modal.subOrders" | translate }}</div>
      <ul class="recurring-children">
        <li v-for="(value,index) in subOrdersList" :key="index" @click="childTransaction(value)">{{value}}</li>
      </ul>
    </vuestic-modal> -->

    <!-- <vuestic-modal
      ref="transactionsModal"
      :okText="'modal.confirm2' | translate"
      style="height: 100%; width: 60vw"
      class="recurrings-payment-order"
      :okClass="'btn btn-primary btn-micro'"
      :cancelClass="'btn btn-secondary btn-micro'"
      :cancelText="'modal.cancel2' | translate"
      :noButtons="true"
      :large="true"
    >
      <div slot="title"> Payment Order Details </div> -->
    <!-- </vuestic-modal> -->
    <!-- <el-dialog
      title="Payment Order Details"
      id="paymentDetails"
      :visible.sync="paymentOrderVisible"
      style="padding-top: 3vh"
    >
      <div class="recurrings-detail-content">
        <recurrings-detail ref="recurringsDetail" :paymentOrderVisible.sync="paymentOrderVisible" :childTransactionId="childTransactionId" :appId="appId" :recurringBean="recurringBean" @searchOrder="searchOrder"/>
      </div>
    </el-dialog> -->

  </div>
</template>

<script>
import RecurringsListFilter from "./RecurringsListFilter.vue"
import Scrollbar from "@/vuestic-theme/vuestic-components/vuestic-scrollbar/VuesticScrollbar.vue";
import RecurringsDetail from "./RecurringsDetail.vue"
import Pagination from "@/components/Pagination";

import {
  request,
} from "@/utils/utils.js";
let moment = require("moment-timezone");

export default {
  name: "Recurrings",
  data() {
    return {
      filterData: {
        valueApp: "",
        valueCurrency: "",
        valueMethod: "",
        valueStatus: "",
        valueTime: "1",
        valueMode: "1",
        searchVal: ""
      },
      currTimeZone: "America/Sao_Paulo",
      dateVals: [],
      appList: [],
      currencyList: [],
      // methodList: [],
      // 订单初始化 INITIAL(1000, "Initial"),正常循环中（等待下次付费） ACTIVE(2000, "Active"),付费中 CHARGING(2001, "Charging"),风控中 CONTROLLING(2002, "Controlling"),取消订阅 CANCEL(3000, "Cancelled"),逾期 PAST_DUE(3001, "Past Due"),正常关闭 CLOSE(4000, "Closed"),拒绝 REFUSED(5000, "Refused")
      statusList: [
        {"desc": "All", "code": ""},
        {"desc": "Initial", "code": "1000"},
        {"desc": "Active", "code": "2000"},
        {"desc": "Charging", "code": "2001"},
        {"desc": "Controlling", "code": "2002"},
        {"desc": "Cancelled", "code": "3000"},
        {"desc": "Past Due", "code": "3001"},
        {"desc": "Closed", "code": "4000"},
        {"desc": "Refused", "code": "5000"}
      ],
      // 1:create_time, 2:update_time, 3:next_time
      timeModeList: {
        "Create Time": "1",
        "Update Time": "2",
        "Next Time": "3"
      },
      timeZoneList: [
        "America/Sao_Paulo",
        "Etc/GMT",
        "Asia/Shanghai",
        "America/Mexico_City",
        "America/Bogota", // 哥伦比亚
        "America/Santiago", // 智利 America/Santiago 首都  Pacific/Easter America/Punta_Arenas
        "America/Lima", // 秘鲁
        "America/Panama", // 巴拿马
        "America/Costa_Rica", // 哥斯达黎加
        "America/Guayaquil", // 厄瓜多尔 America/Guayaquil Pacific/Galapagos
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() + 24 *60* 60 * 1000;
        },
      },
      modeList: {
        // "Transaction ID": "1",
        "Merchant Reference": "1",
        // "Partner ID": "3",
        // "Merchant UID": "4",
        // Email: "5",
        // "User Identify": "6",
      },
      fileTypeOptions: {
        "XLSX": "xlsx",
        "CSV": "csv"
      },
      tableHeaderList: [
        // { label: "tables.listing.recurring_transaction_id", key: "transactionId", id: 0 },
        {
          label: "tables.listing.recurring_merchant_reference",
          key: "merchantReference",
          id: 1,
        },
        {
          label: "tables.listing.app",
          key: "appName",
          id: 2,
        },
        {
          label: "tables.listing.recurring_create_time",
          key: "referenceDateTime",
          id: 3,
        },
        // { label: "tables.listing.recurring_method", key: "method", id: 4 },
        { label: "tables.listing.recurring_order_amount", key: "amount", id: 5 },
        { label: "tables.listing.recurring_status", key: "status", id: 6 },
        // { label: "tables.listing.recurring_buyer_id", key: "muid", id: 7 },
        { label: "tables.listing.recurring_interval", key: "email", id: 8 },
        { label: "tables.listing.recurring_quantity", key: "subject", id: 9 },
        { label: "tables.listing.recurring_current", key: "updateTime", id: 10 },
        { label: "tables.listing.recurring_trial_amount", key: "updateTime", id: 10 },
        { label: "tables.listing.recurring_previous", key: "updateTime", id: 10 },
        { label: "tables.listing.recurring_next", key: "updateTime", id: 10 },
      ],
      list: null, // 请求回来填充表格的数据
      total: 0, // 数据总条数
      page: 1, // 默认显示第1页
      limit: 10, // 默认一次显示10条数据
      noData: this.$t("t.noDataNoOrder"),
      queryDate: {
        start_time: "",
        end_time: "",
      },
      subOrdersList: [],
      childTransactionId: "",
      paymentOrderVisible: false,
      appId: "",
      recurringBean: null
    }
  },
  components: {
    RecurringsListFilter,
    Pagination,
    Scrollbar,
    RecurringsDetail
  },
  watch: {
    currTimeZone: function () {
      this.queryDate.start_time = moment
        .tz(moment.tz(this.dateVals[0], this.currTimeZone), "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
      this.queryDate.end_time = moment
        .tz(moment.tz(this.dateVals[1], this.currTimeZone), "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
    },
    dateVals: function (val) {
      this.queryDate.start_time = moment
        .tz(moment.tz(val[0], this.currTimeZone), "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
      this.queryDate.end_time = moment
        .tz(moment.tz(val[1], this.currTimeZone), "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
    },
  },
  created() {
    this.dateVals.push(
      moment().subtract(31, "days").format("YYYY-MM-DD 00:00:00")
    );
    this.dateVals.push(moment().format("YYYY-MM-DD 23:59:59"));
  },
  mounted() {
    // this.$refs.recurringsModal.ok = () => {};
    // 初始化
    this.initSelectData()
  },
  methods: {
    searchReset() {
      let filterArrayString = ["valueApp","valueCurrency","valueMethod","valueStatus","searchVal"]
      filterArrayString.forEach(value => {
        this.filterData[value] = "";
      })
      this.filterData.valueTime = "1";
      this.filterData.valueMode = "1";
      this.currTimeZone = "America/Sao_Paulo";
      this.dateVals = [];
      this.queryDate.start_time = "";
      this.queryDate.end_time = "";
    },
    searchOrder() {
      // console.log("this.filterData",this.filterData)
      this.page = 1;
      this.orderData();
    },
    orderData() {
      this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
      let start = this.page;
      let end = this.limit;
      let token = localStorage.getItem("Authorization");

      request({
        method: "post",
        url: `api/dashboard/recurring/list?access_token=${token}`,
        data: {
          app_id: this.filterData.valueApp,
          currency: this.filterData.valueCurrency,
          page_num: start,
          page_size: end,
          start_time: this.queryDate.start_time,
          end_time: this.queryDate.end_time,
          date_mode: this.filterData.valueTime,
          search_key: this.filterData.searchVal,
          search_mode: this.filterData.valueMode,
          status: this.filterData.valueStatus
        },
      })
        .then((res) => {
          if (!res) {
            this.searching.close();
            return;
          }
          if (res.data.code == 20000) {
            this.list = [];
            this.total = 0;
            this.noData = this.$t("t.noData");
            setTimeout(() => {
              this.searching.close();
            }, 200);
            return;
          }
          this.list = res.data.data.list;
          this.total = res.data.data.total;
          if (this.list.length == 0) {
            this.noData = this.$t("t.noData");
          }
          setTimeout(() => {
            this.searching.close();
          }, 800);
        })
        .catch((err) => {
          this.searching.close();
        });
    },
    initSelectData() {
      let that = this;
      let token = localStorage.getItem("Authorization");
      let url = "/api/dashboard/basic/getDropdown?access_token=" + token;
      request({
        method: "post",
        url,
      }).then((res) => {
        that.appList = [{ id: "", name: "All" }].concat(res.data.apps);
        that.filterData.valueApp = that.appList[0].id;
        that.currencyList = res.data.order_currency;
        // that.methodList = res.data.method;
        // that.filterPaiedStatus(res.data.trade_status);
      });
    },
    downloadLogs() {
      this.$router.push({'name': 'RecurringDownload'})
    },
    download() {},
    isMobile: function () {
      if (document.body.clientWidth && document.body.clientWidth < 750) {
        return "mobile";
      }
      return "pc";
    },
    loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    dateFormat(value) {
      return moment
        .tz(moment.tz(value, "UTC"), this.currTimeZone)
        .format("YYYY-MM-DD HH:mm:ss");
    },
    getStatusColor(status) {
      // "Initial","Active","Charging","Controlling","Cancelled","Past Due","Closed","Refused"} return ;
      switch (status) {
        case "Success":
          return "#67c23a";
        case "Active":
          return "#909399";
        case "Charging":
          return "#67c23a";
        case "Closed":
          return "#3a517e"
        case "Cancelled":
          return "#75853c";
        case "Past Due":
          return "#e6a23c";
        case "Controlling":
          return "#b1b8c5";
        case "Refused":
          return "#f56c6c";
        default:
          return "#909399";
      }

    },
    fetchDetails(data) {
      this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
      this.appId = data.app_id
      this.recurringBean = data
      let token = localStorage.getItem("Authorization");
      let url = `api/dashboard/recurring/querySubOrdersById?access_token=${token}&app_id=${data.app_id}&out_trade_no=${data.out_trade_no}`;
      request({
        method: "post",
        url: url
      }).then((res) => {
          if (!res) {
            this.searching.close();
            return;
          }
          // if (res.data.code == 20000) {
          //   this.subOrdersList = [];
          //   setTimeout(() => {
          //     this.searching.close();
          //   }, 200);
          //   return;
          // }
          this.subOrdersList = res.data.data.list;
          localStorage.setItem("recurringBean", JSON.stringify(this.recurringBean));
          localStorage.setItem("subOrdersList", JSON.stringify(this.subOrdersList));
          this.$router.push({"path": "RecurringsDetail", "query": {"currTimeZone": this.currTimeZone}})
          // this.$refs.recurringsModal.open();
          setTimeout(() => {
            this.searching.close();
          }, 800);
        })
        .catch((err) => {
          this.searching.close();
        });
    },
    // childTransaction(value) {
    //   this.childTransactionId = value
    //   this.paymentOrderVisible = true;
    // }
  }
}
</script>
<style lang="scss" scoped>
table {
  text-align: center;
}

.alink {
  color: $vue-green;
  text-decoration: underline;
}

@media only screen and (max-width: 750px) {
  .mobile-btn {
    padding: 0.5rem 0.2rem 0;
  }

  /deep/ .pagination-container {
    padding: 5px 4px 10px;
    .el-pagination__total {
      display: block;
      margin-right: 4px;
    }
    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      margin: 0 2px 0;
    }
  }

  /deep/ .pagination-container {
    padding: 5px 4px 10px;
    .el-pagination {
      padding: 0;
      text-align: center;
    }
    .el-pagination__total {
      display: block;
      margin-right: 4px;
    }
    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      margin: 0 1px 0;
    }
  }

  /deep/ .buyer {
    padding-left: 5px;
    width: auto !important;
  }

  #details {
    min-width: 600px;
  }
}
/deep/ .el-pagination {
  text-align: center;
}
/deep/ .recurring-children {
  width: 300px;
  padding: 10px 20px;
  max-height: 350px;
  overflow-y: scroll;
  margin-top: -12px;
  li {
    list-style: none;
    cursor: pointer;
    color: #4ae387;
    text-decoration: underline;
    margin: 8px 0;
  }
}
/deep/ .recurrings-payment-order {
  .modal-dialog {
    margin-top: 0.2vh !important;
  }
  .recurrings-detail-content {
    max-height: 420px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}

/deep/ .el-dialog {
  margin-top: 0.2vh !important;
  width: 98%;
}
/deep/ .el-dialog__header {
  padding: 10px 10px 0 !important;
}
/deep/ .el-dialog__headerbtn {
  position: absolute;
  top: 0;
  right: 5px;
  font-size: 30px;
}
/deep/ .el-dialog__title {
  font-size: 1.375rem;
  font-weight: 600;
}
/deep/ .el-dialog__body {
  padding: 30px !important;
}


</style>
